<template>
  <div>
    <Navbar />
    <div class="d-flex" id="wrapper">
      <div class="bg-light border-right" id="sidebar-wrapper">
        <Sidebar active="Rawat Inap" />
      </div>
      <div id="page-content-wrapper">
        <div class="container-fluid">
          <Alert
            v-if="saveFailed"
            :alert="{
              type: 'danger',
              title: 'Gagal Menyimpan Data',
              content:
                'Terjadi kesalahan saat menyimpan data, mohon periksa kembali data yang Anda masukkan',
            }"
          />
          <Alert
            v-if="saveSuccess"
            :alert="{
              type: 'success',
              title: 'Berhasil Menyimpan Data',
              content: 'Penyimpanan data berhasil dilakukan',
            }"
          />
          <PageContentHeader
            :data="data"
            :fromUrl="fromUrl || ''"
            :fromTab="$route.query.fromTab || ''"
          />
          <DetailTop v-if="detailTop" :detailTop="detailTop" />
          <div class="row mb-4" v-if="detailLeftTop">
            <div class="col-md-12">
              <DetailLeft :detailLeftTop="detailLeftTop" />
            </div>
          </div>
          <!-- <div class="py-1 my-5"></div> -->
          <div class="card p-3">
            <div class="row pt-3">
              <div class="col-md-9 pl-4">
                <FormRow
                  v-for="row in leftForm"
                  v-bind:key="row.colnum + String(Math.random(1023))"
                  :row="row"
                  @handleChange="(e) => handleChange(e)"
                />
              </div>
              <div class="col-md-3 pt-4 pr-4">
                <button
                  @click="handleForm"
                  class="
                    btn-block btn btn-primary btn-with-icon-left
                    text-uppercase
                  "
                  style="margin-top: 0.175rem"
                >
                  <i class="material-symbols-outlined">check_circle</i>
                  simpan tagihan
                </button>
                <!-- <router-link class="btn btn-outline-danger btn-no-outline float-right text-uppercase" to="/ralan">Batalkan</router-link> -->
              </div>
            </div>
          </div>

          <!--/form-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Alert from "@/components/Alert.vue";
import Navbar from "@/components/Navbar.vue";
import Sidebar from "@/components/Sidebar.vue";
import PageContentHeader from "@/components/PageContentHeader.vue";
import FormRow from "@/components/FormRow.vue";
import DetailTop from "@/components/DetailTop.vue";
import DetailLeft from "@/components/DetailLeft.vue";
// import DetailRight from '@/components/DetailRight.vue'
import { setPatientIntro } from "@/data/helper.js";
// import { setPatientIntro, discounted, formatDiscount } from "@/data/helper.js";
//console.log(discounted);
//console.log(formatDiscount);
// import { HTTP } from "@/config.js";
import { dataEdit, leftFormEdit, today } from "@/data/RanapFormTagihan.js";

export default {
  name: "RanapFormTagihan",
  components: {
    Navbar,
    Sidebar,
    PageContentHeader,
    FormRow,
    DetailTop,
    DetailLeft,
    Alert,
  },
  data: () => {
    return {
      fromUrl: "",
      plainUrl: "",
      ranap: null,
      data: dataEdit,
      leftForm: leftFormEdit,
      detailTop: null,
      detailLeftTop: null,
      detailRightTop: null,
      formSet: {
        id_kamar: "",
        tgl: today,
        biaya: 0,
      },
      saveSuccess: false,
      saveFailed: false,
    };
  },
  methods: {
    goBack(url) {
      // //console.log(this.fromUrl);
      let urlArray = this.fromUrl.split("?");
      let backBtn = urlArray[0];
      // //console.log(backBtn);
      // //console.log(window.history.back);

      if (
        !backBtn ||
        this.fromUrl.indexOf("form") > -1 ||
        this.fromUrl.indexOf("edit") > -1 ||
        this.fromUrl.indexOf("cetak") > -1
      ) {
        if (url)
          this.$router.push({
            path:
              url +
              (this.$route.query.fromTab
                ? "?tab=" + this.$route.query.fromTab
                : ""),
          });
        else this.$router.go(-1);
      } else if (this.$route.query.fromTab) {
        let queryString = "?";
        let tabQuery = "tab=" + this.$route.query.fromTab;
        if (urlArray[1]) {
          if (urlArray[1].toLowerCase().indexOf(tabQuery.toLowerCase()) < 0) {
            if (urlArray[1].indexOf("tab=") > -1) {
              let queryArray = urlArray[1].split("tab=");
              if (queryArray[1]) {
                let restQueryArray = queryArray[1].split("&");
                restQueryArray[0] = this.$route.query.fromTab;
                queryArray[1] = restQueryArray.join("&");
              }
              urlArray[1] = queryArray.join("tab=");
            } else {
              queryString += tabQuery + "&";
            }
          }
          queryString += urlArray[1];
        } else {
          queryString += tabQuery;
        }
        // //console.log(backBtn)
        this.$router.push({ path: backBtn + queryString });
      } else {
        // //console.log(window.history);
        let queryString = "";
        if (urlArray[1]) {
          queryString += "?" + urlArray[1];
        }
        this.$router.push({ path: backBtn + queryString });
      }
    },
    handleForm: async function() {
      this.errors = [];
      // let formData = new FormData();
      let body = "";
      var self = this;
      let valid = this.validateForm();
      if (valid) {
        // formData.append('id_form',this.$route.params.id_form);
        Object.keys(this.formSet).forEach(function(key) {
          // formData.append(key, self.formSet[key]);
          body += key + "=" + self.formSet[key] + "&";
        });
        body += "id_ranap=" + this.$route.params.id;
        // body=`id_kamar=${self.formSet['id_kamar']}&tgl=${self.formSet['tgl']}`;
        try {
          //console.log(formData);
          // let result = await this.$store.state.HTTP.put(`/ranap/tagihan/kamar/${this.$route.params.id_form}`, formData);
          let result = await this.$store.state.HTTP.put(
            `/ranap/tagihan/kamar/${this.$route.params.id_form}`,
            body
          );
          //console.log(result);
          if (result.status == "200") {
            this.saveFailed = false;
            this.saveSuccess = true;
            var that = this;
            setTimeout(function() {
              that.saveSuccess = false;
              that.$router.push(
                `/ranap/detail/${that.$route.params.id}?tab=kamar`
              );
            }, 1000);
          } else {
            //console.log(result.status);
            this.errors.push(result.status);
            this.saveFailed = true;
          }
        } catch (e) {
          //console.log(e);
          this.errors.push(e);
          this.saveFailed = true;
        }
      } else {
        //console.log("tidak valid");
      }
    },
    handleChange(e) {
      if (e.target.type == "file") {
        if (e.target.files && e.target.files.length) {
          this.formSet[e.target.name] = e.target.files[0];
        }
      } else {
        if (e.target.name == "id_kamar") {
          this.setPrice(e.target.value);
        }
        this.formSet[e.target.name] = e.target.value;
      }
    },
    setPrice: async function(id_kamar) {
      //console.log(id_kamar);
      //console.log(this.rooms);
      // let result = await this.$store.state.HTTP.get(`ranap/fasilitas/kamar/${id_kamar}`);
      //console.log(result);
      let room = this.rooms.find(function(room) {
        return room.id == id_kamar;
      });
      //console.log(room);
      if (room) {
        this.formSet.biaya = room.biaya;
      } else {
        this.formSet.biaya = 0;
      }
      this.leftForm[0].columns[2].value = this.formSet.biaya;
    },
    validateForm: function() {
      let valid = true;
      let self = this;
      //console.log(self.formSet);
      let forms = [this.leftForm].map(function(form) {
        form = form.map(function(row) {
          row.columns = row.columns.map(function(column) {
            if (
              !column.optional &&
              column.type != "hidden" &&
              !self.formSet[column.name]
            ) {
              valid = false;
              column.error = "Kolom ini wajib diisi";
            } else {
              column.error = "";
            }
            if (self.formSet[column.name]) {
              column.value = self.formSet[column.name];
            }
            return column;
          });
          return row;
        });
        return form;
      });
      this.leftForm = forms[0];
      this.rightVital = forms[1];
      //console.log(self.formSet);
      return valid;
    },
    fetchRooms: async function() {
      try {
        let result = await this.$store.state.HTTP.get(
          "ranap/fasilitas/kamar?per_page=9999999999&status=KOSONG"
        );
        //console.log(result);
        if (result.status == "200") {
          //console.log(result.data);
          this.rooms = result.data.data;
          //console.log(doctors);
          //console.log(this.formSet['id_kamar']);
          // if(this.formSet['id_kamar']){
          //   this.leftForm[0].columns[1].value=this.formSet['id_kamar'];
          // }
          //console.log(this.rooms);
          if (this.ranap && this.ranap.kamar_ranap) {
            this.formSet["id_kamar"] = this.ranap.kamar_ranap.id;
            this.rooms = [this.ranap.kamar_ranap, ...this.rooms];
          }
          //console.log(this.ranap);
          //console.log(this.rooms);
          this.leftForm[0].columns[1].options = this.rooms.map(function(item) {
            item.label = `${item.formatted_kelas} | ${item.nama}  [ ${item.formatted_no_kasur} ]`;
            item.value = item.id;
            return { label: item.label, value: item.value };
          });
        } else {
          this.displayNotFoundError();
        }
      } catch (e) {
        //console.log(e);
      }
      // Object.keys(this.formSet).forEach(function(key){
      //     self.formSet[key]=data[key];
      // });
    },
    fetchData: async function() {
      let result = await this.$store.state.HTTP.get(
        `ranap/tagihan/kamar/${this.$route.params.id_form}`
      );
      //console.log(result);
      this.formSet.id_kamar = result.data.id_kamar;
      this.formSet.tgl = result.data.tgl;
      this.formSet.biaya = result.data.biaya;
      this.updateForm();
    },
    updateForm() {
      let self = this;
      let forms = [this.leftForm].map(function(form) {
        form = form.map(function(row) {
          row.columns = row.columns.map(function(column) {
            if (
              (self.formSet[column.name] &&
                self.formSet[column.name] != null &&
                self.formSet[column.name] != "null") ||
              self.formSet[column.name] == 0
            ) {
              column.value = self.formSet[column.name];
            }
            return column;
          });
          return row;
        });
        return form;
      });
      this.leftForm = forms[0];
      this.leftForm.splice(0, 1, this.leftForm[0]);
      //console.log(this.leftForm);
    },
    displayData: async function() {
      this.errors = [];
      try {
        let result = await this.$store.state.HTTP.get(
          `ranap/${this.$route.params.id}`
        );
        //console.log(result);
        if (result.status == "200") {
          //console.log("berhasil");
          // this.rows = result.data;
          //console.log(this.rows);
          let dataPasien = result.data.pasien;
          //console.log(dataPasien);
          this.ranap = result.data;
          this.fetchRooms();

          //console.log(this.detailTop);

          let ralan = result.data.ralan;
          this.idRalan = ralan.id;
          this.darurat = ralan.darurat;
          this.no_rawat = this.ranap.no_rawat;
          // this.formSet.id_kamar=this.ranap.id_kamar;
          //console.log(ralan);
          this.detailTop = setPatientIntro(dataPasien);
          this.fetchData();
          this.detailLeftTop = [
            {
              key: String(Math.random(1023)),
              columns: [
                {
                  label: "No. Registrasi   |    No. Rawat",
                  content: ralan.formatted_no_reg_rawat,
                  icon: "confirmation_number",
                  colwidth: 4,
                },
                {
                  label: "Kamar Inap",
                  content:
                    this.ranap.kamar_this.ranap.nama +
                    " | " +
                    this.ranap.kamar_this.ranap.formatted_kelas,
                  icon: "hotel",
                  colwidth: 4,
                },
                {
                  label: "Nomor Kasur",
                  content: this.ranap.kamar_this.ranap.formatted_no_kasur,
                  icon: "radio_button_checked",
                  colwidth: 4,
                },
              ],
            },
          ];
        } else {
          //console.log(result.status);
          this.errors.push(result.status);
        }
      } catch (e) {
        //console.log(e);
        this.errors.push(e);
      }
    },
  },
  beforeRouteEnter: function(to, from, next) {
    next((vm) => {
      vm.fromUrl = ["", "/"].indexOf(from.path) > -1 ? "" : from.fullPath;
      ////console.log(vm.fromUrl);
    });
  },
  // created() {
  //   window.addEventListener(
  //     "hashchange",
  //     () => {
  //       // Do something when the hash changes
  //       location.reload();
  //     },
  //     false
  //   );
  // },
  mounted: async function() {
    let url = `/ranap/detail/${this.$route.params.id}`;
    this.data.backBtn = url;
    this.data.breadcrumb[0].link = url;
    this.displayData();
  },
};
</script>
